import type { EventProperties } from './types';

function getUtmProperties(searchParams: URLSearchParams): EventProperties {
  return {
    utm_source: searchParams.get('utm_source') ?? undefined,
    utm_medium: searchParams.get('utm_medium') ?? undefined,
    utm_campaign: searchParams.get('utm_campaign') ?? undefined,
    utm_term: searchParams.get('utm_term') ?? undefined,
    utm_content: searchParams.get('utm_content') ?? undefined,
  };
}

export function getBrowserContextProperties(): EventProperties {
  if (typeof window === 'undefined') {
    return {};
  }

  const url = new URL(window.location.href);
  return {
    page_path: url.pathname,
    page_url: url.href,
    page_title: document.title || undefined,
    referrer: document.referrer || undefined,
    ...getUtmProperties(url.searchParams),
  };
}
